import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Table, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminCourseStudentOverview = () => {
    const navigate = useNavigate();
    return (
        <>
            <Row gutter={[8, 8]} justify={'space-between'}>
                <Col style={{ fontSize: '1.3rem', fontWeight: 400 }}>111-1英文衝刺班</Col>
                <Col>
                    <Button className='example' icon={<PlusOutlined />} style={{ background: '#FdF9C9', display: "inline-flex", alignItems: "center" }} >新增學員</Button>
                </Col>
                <Col span={24}>
                    <Table columns={[{
                        title: '編號',
                        dataIndex: 'week'
                    }, {
                        title: '照片',
                        dataIndex: 'content'
                    }, {
                        title: '姓名',
                        dataIndex: 'content'
                    }, {
                        title: '英文姓名',
                        dataIndex: 'content'
                    }, {
                        title: '聯絡人姓名',
                        dataIndex: 'content'
                    }, {
                        title: '聯絡人電話',
                        dataIndex: 'content'
                    }, {
                        title: '出席狀況',
                        dataIndex: 'content'
                    }, {
                        title: '備註',
                        dataIndex: 'content'
                    }]}></Table>
                </Col>
            </Row >

        </>
    )
}
export default AdminCourseStudentOverview;